import React from 'react';
import './Hero.css';

const Hero = () => {
    const openGoogleMaps = () => {
        window.open('https://www.google.com/maps/place/Strefa+Nap%C4%99du/@50.0455414,21.9678707,17z/data=!3m1!4b1!4m6!3m5!1s0x473cfb0a5b067467:0x74b40195e81d8c0f!8m2!3d50.045538!4d21.9704456!16s%2Fg%2F11zb5r3jy7?entry=ttu&g_ep=EgoyMDI2MDUwNi4wIKXMDSoASAFQAw%3D%3D', '_blank');
    };

    const scrollToContact = () => {
        const element = document.getElementById('contact');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section id="home" className="hero">
            <div className="hero-overlay"></div>
            <div className="container">
                <div className="hero-content">
                    <h1>Profesjonalny serwis samochodowy <span className="highlight">w Rzeszowie</span></h1>
                    <p>Hybrydy • Elektryki • Samochody spalinowe • Kompleksowa naprawa silników i skrzyń biegów</p>
                    <div className="hero-buttons">
                        <button onClick={scrollToContact} className="btn btn-primary">
                            Umów wizytę
                        </button>
                        <button onClick={openGoogleMaps} className="btn btn-outline">
                            <i className="fab fa-google"></i> Google Maps
                        </button>
                    </div>
                    <div className="hero-stats">
                        <div className="stat">
                            <div className="stat-number">5.0</div>
                            <div className="stat-label">⭐ Ocena Google</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">+200</div>
                            <div className="stat-label">Zadowolonych klientów</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">5+</div>
                            <div className="stat-label">Lat doświadczenia</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;